// What is open in the app right now - the page and, when a page has one open, the record (an equipment, an order ...) - so
// the floating assistant knows that "this pump" / "this order" means the open record. Pages report it (App: the page;
// DataTable / Purchase Orders: the record they open), the chat sends it with each question (context), the server tells the model.

let state = { page: null, pageTitle: '', record: null }
const subs = new Set()
const emit = () => subs.forEach(f => { try { f(state) } catch (e) {} })

export function setPageContext(page, pageTitle) {
  state = state.page === page ? { ...state, pageTitle: pageTitle || state.pageTitle } : { page, pageTitle: pageTitle || '', record: null }
  emit()
}
// rec: { type: 'Equipment', label: 'Port Generator', id, table } or null when it is closed
export function setRecordContext(rec) {
  state = { ...state, record: rec && rec.label ? { type: String(rec.type || 'Record').slice(0, 40), label: String(rec.label).slice(0, 120), id: rec.id != null ? String(rec.id).slice(0, 64) : null, table: rec.table || null } : null }
  emit()
}
// close it only when it is still the one this page opened (another page may have opened its own in between)
export function clearRecordContext(id) { if (state.record && (id == null || state.record.id === String(id))) { state = { ...state, record: null }; emit() } }
export const getAppContext = () => state
export function subscribeAppContext(fn) { subs.add(fn); return () => subs.delete(fn) }

// the floating assistant: Cmd / Ctrl + K opens / closes it; it is not shown on the Chat page or for a login without AI access
export const isAssistantShortcut = e => !!e && (e.metaKey || e.ctrlKey) && !e.altKey && !e.shiftKey && String(e.key || '').toLowerCase() === 'k'
export const assistantVisible = (page, aiAllowed) => !!aiAllowed && page !== 'chat'
// a login may use the assistant: not a crew login with the AI module hidden, the module readable and switched on
export const aiAllowedFor = ({ accountType, permissions, can, hasFeature }) =>
  !(accountType === 'crew' && (permissions || {}).ai === 'none') && (!can || can('ai', 'read')) && (!hasFeature || hasFeature('ai'))

// the emergency run open on this device (src/lib/emergencyStore.js): sent with each question so the assistant can say / tick the
// next step of a run THIS login started (api/_contingency.js checks the login); null when none
export function setEmergencyContext(em) { state = { ...state, emergency: em || null }; emit() }
